interface Props {
  children: React.ReactNode;
  className?: string;
}

export function BrandedAppBackground({ children, className }: Props) {
  return <div className={className}>{children}</div>;
}
